/**
 * Move slideshow buttons into an independent CTA slot so heading/subheading
 * and buttons can use separate place-self positions. Theme Check allows only
 * one content_for 'blocks' per slide, so the split happens in the DOM.
 */
(function () {
  if (window.customElements.get('slideshow-overlay')) return;

  class SlideshowOverlay extends HTMLElement {
    connectedCallback() {
      this._moveButtons();

      if (this._observer) return;

      this._observer = new MutationObserver(() => {
        if (this._moving) return;
        this._moveButtons();
      });
      this._observer.observe(this, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }

    _moveButtons() {
      const text = this.querySelector(':scope > .slideshow__text .prose') || this.querySelector(':scope > .slideshow__text');
      const cta = this.querySelector(':scope > .slideshow__cta');
      if (!text || !cta) return;

      const movers = [];
      for (const el of text.children) {
        if (this._isButtonSlot(el)) movers.push(el);
      }
      if (!movers.length) return;

      this._moving = true;
      for (const el of movers) cta.appendChild(el);
      this._moving = false;
    }

    _isButtonSlot(el) {
      if (!(el instanceof Element)) return false;
      if (el.matches('.button, .button-group, a.button, button.button')) return true;
      return el.matches(':has(> .button, > .button-group, > a.button, > button.button)');
    }
  }

  window.customElements.define('slideshow-overlay', SlideshowOverlay);
})();
